module.exports = __webpack_public_path__ + "static/media/curology-bottles-in-white-cabinet.dd7a6c06.jpg";